import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  signal,
} from '@angular/core';
import type { CategoryTreeItemDto } from '@api/models';

import { RouterLinkWithLang } from '../../../directives/router-link-with-lang/router-link-with-lang.directive';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'catalog-menu',
  templateUrl: './catalog-menu.component.html',
  styleUrls: ['./catalog-menu.component.scss'],
  imports: [RouterLink, RouterLinkWithLang],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogMenuComponent {
  readonly categories = input<CategoryTreeItemDto[]>(undefined);
  readonly menuMouseLeave = output<void>();

  activeCategoryIndex = signal(0);

  onMouseLeave(): void {
    this.menuMouseLeave.emit();
  }

  setActiveIndex(index: number): void {
    this.activeCategoryIndex.set(index);
  }
}
